import { AuthConfig } from './auth.types';

export const authConfig: AuthConfig = {
    //apiBaseUrl: process.env.REACT_APP_API_URL || "https://localhost:7297/api",
    //apiBaseUrl: "http://localhost:5297/api", // Use HTTP
    apiBaseUrl: process.env.REACT_APP_SAML_API_URL, //"https://localhost:7297/api",

    // SAML-specific endpoints
    saml: {
        loginUrl: "/saml/login",
        logoutUrl: "/saml/logout",
        successUrl: "/saml/success",
        token: "/saml/token"
    },

    // JWT endpoints (existing)
    //jwt: {
    //    loginUrl: "/auth/login",
    //    logoutUrl: "/auth/logout",
    //    refreshUrl: "/auth/refresh"
    //},
};